import { handleRequest, apiClient } from '@/shared/api';
import type {
  ExchangeAssetsRequestDto,
  ExchangeAssetsResponseDto,
  GetAssetsExchangeRatesRequestArgs,
  GetAssetsExchangeRatesResponseDto,
} from './types';

export const getAssetsExchangeRates = async ({
  assetCodeToPay,
  assetCodeToReceive,
}: GetAssetsExchangeRatesRequestArgs) => {
  const request = () =>
    apiClient.get(
      `/assets/prices?assetFrom=${assetCodeToPay}&assetTo=${assetCodeToReceive}`
    );
  const response =
    await handleRequest<GetAssetsExchangeRatesResponseDto>(request);
  return response.data;
};

export const exchangeAssets = async (args: ExchangeAssetsRequestDto) => {
  const request = () => apiClient.post('/operations/exchange/stack', args);
  const response = await handleRequest<ExchangeAssetsResponseDto>(request);
  return response.data;
};
